import { useEffect, useState } from 'react';

import {
    DEFAULT_BANNER_TOP_PX,
    ESTIMATE_NAV_SCROLL_TRIGGER_PX,
    ESTIMATE_NAV_SCROLLED_TOP_PX,
    ESTIMATE_NAV_TOP_EXTRA_OFFSET_PX,
} from '../../model/consts';

const ESTIMATE_NAV_SELECTOR = '.estimate-nav';

export const useScrollConversationBanner = () => {
    const [topOffset, setTopOffset] = useState(DEFAULT_BANNER_TOP_PX);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const updateTopOffset = () => {
            const estimateNav = document.querySelector(ESTIMATE_NAV_SELECTOR);
            const hasEstimateNav = !!estimateNav;
            const isScrolled = window.scrollY >= ESTIMATE_NAV_SCROLL_TRIGGER_PX;

            const nextTopOffset = hasEstimateNav
                ? isScrolled
                    ? ESTIMATE_NAV_SCROLLED_TOP_PX
                    : DEFAULT_BANNER_TOP_PX + ESTIMATE_NAV_TOP_EXTRA_OFFSET_PX
                : DEFAULT_BANNER_TOP_PX;
            setTopOffset(nextTopOffset);
        };

        window.addEventListener('scroll', updateTopOffset, { passive: true });
        window.addEventListener('resize', updateTopOffset);
        updateTopOffset();

        return () => {
            window.removeEventListener('scroll', updateTopOffset);
            window.removeEventListener('resize', updateTopOffset);
        };
    }, []);

    return topOffset;
};
